var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7692 36C16.8 36 18.4615 34.3385 18.4615 32.3077H11.0769C11.0769 34.3385 12.7385 36 14.7692 36ZM25.8462 24.9231V15.6923C25.8462 10.0246 22.8369 5.28 17.5385 4.02462V2.76923C17.5385 1.23692 16.3015 0 14.7692 0C13.2369 0 12 1.23692 12 2.76923V4.02462C6.72 5.28 3.69231 10.0062 3.69231 15.6923V24.9231L0 28.6154V30.4615H29.5385V28.6154L25.8462 24.9231ZM22.1538 26.7692H7.38462V15.6923C7.38462 11.1138 10.1723 7.38462 14.7692 7.38462C19.3662 7.38462 22.1538 11.1138 22.1538 15.6923V26.7692Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.acc58066b0afadf13f34391ec78a666c.svg";
export { ForwardRef as ReactComponent };